import { Box, Flex, HStack, StyleProps, VStack } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import React, { PropsWithChildren } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type SectionProps = {
  title?: string;
  description?: React.ReactNode;
  icon?: keyof typeof IconMap;
  textAlign?: StyleProps['textAlign'];
  titleSize?: StyleProps['fontSize'];
};

export const Section: React.FC<PropsWithChildren<SectionProps & StyleProps>> = ({
  children,
  title,
  description,
  icon,
  textAlign,
  titleSize,
  ...props
}) => {
  return (
    <Flex flexDirection={'column'} gap="24px" paddingY="36px" width="full" {...props}>
      {(title || icon || description) && (
        <VStack alignItems={props.alignItems ?? 'flex-start'} textAlign={textAlign}>
          {(title || icon) && (
            <HStack>
              <TextBlock fontSize={titleSize ?? ['16px', '16px', '16px', '24px']} weight="bold">
                {title}
              </TextBlock>
              {icon && <Icon icon={icon} color={'blackAlpha.300'} boxSize="14px" variant="regular" />}
            </HStack>
          )}
          {description && (
            <Box color={'blackAlpha.500'} fontSize="16px">
              {description}
            </Box>
          )}
        </VStack>
      )}
      {children}
    </Flex>
  );
};
